// Runtime face-animation kill switch — the Anim Test Panel's FACE ANIM toggle.

const state = { enabled: true }
const listeners = new Set()

export function isFaceAnimEnabled() { return state.enabled }

/** Set and notify; returns the new value. Anything but false enables. */
export function setFaceAnimEnabled(enabled) {
  const next = enabled !== false
  if (next === state.enabled) return state.enabled
  state.enabled = next
  for (const listener of listeners) listener(next)
  return next
}

export function subscribeFaceAnim(listener) {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

if (typeof window !== 'undefined') {
  window.__FACE_ANIM__ = { get enabled() { return state.enabled }, set: setFaceAnimEnabled }
}
